<div class="search-block">
<div class="container">
<div>
<div id="home_nav" class="row">
  <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
    <ol class="breadcrumb loginMenu" >
      <li class="breadcrumb-item" style="align-items: center;float:right;">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="handleNavigation('home')">Home</a>
      </li>
      <li class="breadcrumb-item active">Help Articles</li>
    </ol>
  </div>
  <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
    <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
      [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
      (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
      (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()" aria-label="Type here to Search an Article"
      placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
      No Suggestion...
    </ng-template>
    <span class="input-group-append" (click)="search(searchKey)">
      <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
        <i class="fa fa-search"></i>
      </button>
    </span>
  </div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
</div>
</div>
</div>
<div class="container py-3">
<div class="card-body" status="true">
  <div class="row">
    <div class="col-sm-12 col-xs-12 col-lg-6 col-xl-6" *ngFor="let ht of helpTopics.return_body">
      <div *ngIf="ht.externalUrl!='null' &&ht.navigation==null">
      <a class="chip btn btn-primary top-articles-support-tooltip" (click)="navigate(ht.pk)" >
        <div class="topic-name" tooltip={{ht.stepName}} placement="top" show-delay="100">{{ht.stepName}}</div>
        <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
      </a>
      </div>
      <div *ngIf="ht.externalUrl==''">
        <a class="chip btn btn-primary top-articles-support-tooltip" (click)="navigate(ht.pk)" >
          <div class="topic-name" tooltip={{ht.stepName}} placement="top" show-delay="100">{{ht.stepName}}</div>
          <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
        </a>
        </div>
      <a class="chip btn btn-primary top-articles-support-tooltip" href="{{ht.externalUrl}}"  target="_blank" *ngIf="ht.navigation=='_blank'">
        <div class="topic-name"  tooltip={{ht.stepName}} placement="top" show-delay="100" >{{ht.stepName}}</div>
        <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
      </a>
      <a class="chip btn btn-primary top-articles-support-tooltip" href="{{ht.externalUrl}}"  target="_blank" *ngIf="ht.navigation=='false' && ht.externalUrl">
        <div class="topic-name"  tooltip={{ht.stepName}} placement="top" show-delay="100" >{{ht.stepName}}</div>
        <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
      </a>
    </div>
  </div>
</div>
</div>
